import React, {Component} from 'react';

import styled from 'styled-components';
import Header from "../template/header";
import Leftnav from "../template/leftnav";
import TopSimple from "./top-simple";
import QuoteTop from "./quote-top";
import ApplicationTop from "./application_top";
import Payment from "../payment/payment";
import PaymentTop from "./payment_top";
import AppVersion from "../version";
import {mdDownN} from "../../ui/common";

const TemplateStyle = styled.div`
    height: 100%;
    width: 1440px;
    margin: auto;
    position: relative;
    overflow: visible;
    ${mdDownN`
        width: 100vw;
        min-width: 100vw;
        padding-bottom: 43px;
    `}
`;

const BodyGroupStyle = styled.div`
    top: 144px;
    height: ${props => props.height ? props.height : 'auto'};

    width: 600px;
    position: absolute;
    left: 420px;
    margin: 0;
    padding-bottom: 30px;
    ${mdDownN`
        top: auto;
        // top: 27px;
        top: 132px;
        left:auto;
        position: relative;
        margin: 0px auto;
        // margin-left:15px;
        // margin-right: auto;
        width: calc(100vw - 30px);
        box-shadow: rgba(20, 40, 75, 0.2) 4px 4px 12px 0px;
        text-align:center;
        padding-bottom: 48px;

    `}
`;

const BodyGroupBackgroundStyle = styled.div`
    top: 0px;
    height: 98%;
    width: 600px;
    position: absolute;
    left: 0px;
    box-shadow: rgba(20, 40, 75, 0.2) 4px 4px 12px 0px;
    margin: 0px;
    ${mdDownN`
        left:auto;
        top: auto;
        position: relative;
        width: 100%;
        width: calc(100vw - 30px);
        overflow-y: scroll;
        display: none;
    `}
`;



const BodyStyle = styled.div`
    height: auto;
    width: 600px;
    font-family: "Stag-Medium", Helvetica, Arial, serif;
    font-size: 32.0px;
    text-align: center;
    ${mdDownN`
        display: flex;
        flex-direction: column;
        align-items:center;
        justify-content: center;
        position: relative;
        width: 100%;
    `}
`;

const Template = (props) => {
    return (
            <TemplateStyle id="Template">
                <Header step={props.step} site={props.site} hideBackBtn={props.hideBackBtn} prevPage={props.prevPage}/>
                {  props.leftNav &&
                    <Leftnav id="Leftnav" policy={props.policy}/>
                }
                <BodyGroupStyle height={props.height}>
                    <BodyGroupBackgroundStyle/>
                    {
                        props.application && <ApplicationTop />
                        ||
                        props.payment && <PaymentTop />
                        ||
                        props.simple && <TopSimple title={props.simple}/>
                        ||
                        <QuoteTop />
                    }

                    <BodyStyle>
                        { props.children }
                    </BodyStyle>
                </BodyGroupStyle>
                <AppVersion/>
            </TemplateStyle>
    );
}

export default Template;
